import { useState } from "react";
import { MetadataType } from "types";

import styles from "./styles.module.scss";

export interface MetadataOptionsProps {
  options: { icon: JSX.Element; title: string; type: MetadataType }[];
  onViewClick: (type: MetadataType) => void;
  onViewAllClick: (type: MetadataType) => void;
}

interface SingleMetadataOptionsProps {
  title: string;
  icon: JSX.Element;
  onViewClick: () => void;
  onViewAllClick: () => void;
}

const SingleMetadataOption = ({
  title,
  icon,
  onViewClick,
  onViewAllClick,
}: SingleMetadataOptionsProps) => {
  const [isHovering, setIsHovering] = useState(false);
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className={styles.singleMetadataOption}
      onMouseOver={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div className={styles.optionIcon}>{icon}</div>
      <div className={styles.optionTitle}>{title}</div>

      {isHovering && (
        <div className={styles.actionButtons}>
          <div className={styles.actionButton} onClick={onViewClick}>
            View
          </div>
          <div className={styles.actionButton} onClick={onViewAllClick}>
            View on all
          </div>
        </div>
      )}
    </div>
  );
};

const MetadataOptions = ({
  options,
  onViewClick,
  onViewAllClick,
}: MetadataOptionsProps) => {
  return (
    <div className={styles.metadataOptionsContainer}>
      <div className={styles.heading}>Select Metadata Type</div>
      {options.map((option, index) => {
        return (
          <SingleMetadataOption
            key={index}
            icon={option.icon}
            title={option.title}
            onViewClick={() => onViewClick(option.type)}
            onViewAllClick={() => onViewAllClick(option.type)}
          />
        );
      })}
    </div>
  );
};

export default MetadataOptions;
